var _path, _path2, _path3, _path4, _path5;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } } return target; }
import * as React from "react";
import { forwardRef } from "react";
var SvgPeople = function SvgPeople(_ref, ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3 15.75V2.25C3 1.836 3.336 1.5 3.75 1.5H12.75C13.9927 1.5 15 2.50725 15 3.75V14.25C15 15.4927 13.9927 16.5 12.75 16.5H3.75C3.336 16.5 3 16.164 3 15.75Z",
    fill: "#C5C5CA"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M9 9C10.2426 9 11.25 7.99264 11.25 6.75C11.25 5.50736 10.2426 4.5 9 4.5C7.75736 4.5 6.75 5.50736 6.75 6.75C6.75 7.99264 7.75736 9 9 9Z",
    fill: "#737B7E"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M11.25 10.5H6.75C5.92125 10.5 5.25 11.1712 5.25 12C5.25 12.8287 5.92125 13.5 6.75 13.5H11.25C12.0787 13.5 12.75 12.8287 12.75 12C12.75 11.1712 12.0787 10.5 11.25 10.5Z",
    fill: "#737B7E"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M3 11.25C2.8845 11.25 2.76975 11.25 2.625 11.25C2.004 11.25 1.5 11.754 1.5 12.375C1.5 12.996 2.004 13.5 2.625 13.5C2.76975 13.5 2.8845 13.5 3 13.5V11.25Z",
    fill: "#737B7E"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M3 4.5C2.8845 4.5 2.76975 4.5 2.625 4.5C2.004 4.5 1.5 5.004 1.5 5.625C1.5 6.246 2.004 6.75 2.625 6.75C2.76975 6.75 2.8845 6.75 3 6.75V4.5Z",
    fill: "#737B7E"
  })));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgPeople);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "people.0aa151e40428fa1de2b4552190732de7.svg";